export enum MessageSort {
  MostRecent = 'Most Recent',
  LeastRecent = 'Least Recent',
  MostLiked = 'Most Liked',
  LeastLiked = 'Least Liked',
  NameAZ = 'Name A-Z',
  NameZA = 'Name Z-A',
  Longest = 'Longest',
  Shortest = 'Shortest',
}